export default __webpack_public_path__ + "static/media/Extreme Edge.73714176.png";